<template>
  <div class="daily">
    <van-field
      readonly
      clickable
      name="calendar"
      :value="currentDate"
      label="日历"
      placeholder="点击选择日期"
      @click="showCalendar = true"
    >
      <template #button>
        <el-button
          size="mini"
          type="primary"
          @click.stop="queryDailyReportData"
        >查询</el-button>
      </template>
    </van-field>
    <van-calendar
      v-model="showCalendar"
      @confirm="onConfirm"
      :maxDate="maxDate"
      :minDate="minDate"
    />
    <div
      class="daily-iframe"
      v-if="pageInfo.filePath"
    >
      <van-tabs
        v-model="active"
        @change="tabChange"
        :ellipsis="false"
      >
        <van-tab
          v-for="item in htmlList"
          :key="item.name"
          :title="item.name"
        >
          <iframe
            :src="item.path"
            frameborder="0"
            @load="adjustIframe"
          ></iframe>
        </van-tab>
      </van-tabs>
      <!-- <div class="daily-swipe">
        <van-swipe
          ref="swipe"
          class="my-swipe"
          :autoplay="'none'"
          indicator-color="white"
        >
          <van-swipe-item
            v-for="item in htmlList"
            :key="item.name"
          >
            <iframe
              :src="item.path"
              frameborder="0"
            ></iframe>
          </van-swipe-item>
        </van-swipe>

      </div> -->
    </div>

    <div v-else>
      <van-divider>暂无数据</van-divider>
    </div>
  </div>
</template>

<script>
import hisService from "@/apis/his/index.js";
import moment from "moment";
import { encode } from "js-base64";

export default {
  data() {
    return {
      active: "",
      showCalendar: false,
      currentDate: moment().subtract(1, "d").format("YYYY-MM-DD"),
      pageInfo: {},
      maxDate: moment().toDate(),
      minDate: moment().subtract(3, "M").toDate(),
      isIos: /(iPhone|iPod|iPad)/i.test(navigator.userAgent),
      htmlList: [],
    };
  },
  created() {
    document
      .querySelector("#_view")
      .setAttribute("content", "width=device-width,minimum-scale=0.1");
    this.queryDailyReportData();
  },
  methods: {
    queryDailyReportData() {
      const { currentDate } = this;
      const params = {
        operate_date: currentDate,
      };
      this.pageInfo = {};
      hisService
        .queryDailyReportData(params)
        .then((res) => {
          res.filePath = `https://file.kkview.cn/onlinePreview?url=${encodeURIComponent(
            encode(res.path)
          )}`;
          res.filePath = res.filePath.replace(
            new RegExp("&officePreviewType=xlsx", "gm"),
            ""
          );
          res.filePath = res.filePath + "&officePreviewType=html";
          // res.filePath = `https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(
          //   res.path
          // )}`;
          res.filePath = `https://docs.qq.com/sheet/DRHhibWN5a3d6ZWdV?tab=000001`;
          res.path = `https://docs.qq.com/sheet/DRHhibWN5a3d6ZWdV?tab=000001`;

          this.pageInfo = res;
          this.active = 0;

          // res.file_html.forEach((item) => {
          //   item.path = "http://192.168.124.42:804/excel/ExcelToHTML2.html";
          // });
          this.htmlList = res.file_html;
          // this.$nextTick(() => {
          //   this.$refs.swipe.swipeTo(0);
          // });
        })
        .catch(() => {});
    },
    tabChange(name) {
      console.log(name);
      // this.$refs.swipe.swipeTo(name);
      // console.log(name);
    },
    onConfirm(date) {
      this.showCalendar = false;
      this.currentDate = moment(date).format("YYYY-MM-DD");
      this.queryDailyReportData();
    },
    adjustIframe(e) {
      console.log(e);
      // const iframe = e.target;

      // iframe.style.width = 960 + "px";

      // iframe.style.transform = `scale(${390 / 960})`;
      // iframe.style.transformOrigin = `left top`;

      // const iframeWin = iframe.contentWindow;
      // const iframeDoc = iframeWin.document;
      // const iframeBody = iframeDoc.body;
    },
  },
};
</script>

<style lang="scss" scoped>
.daily {
  height: 100%;
  display: flex;
  flex-direction: column;
  .daily-iframe {
    flex: 1;
    width: 100%;
    display: flex;
    flex-direction: column;
  }
  .daily-swipe {
    flex: 1;
  }
  .my-swipe {
    height: 100%;
  }
  iframe {
    height: 100%;
    width: 100%;
  }
}
</style>
<style lang="scss">
.daily {
  .van-tabs {
    height: 100%;
    display: flex;
    flex-direction: column;
    .van-tabs__content {
      height: 100%;
      flex: 1;
    }
  }
  .van-tab__pane {
    height: 100%;
  }
}
</style>
